<script lang="ts">

    import IconStylusForInput from "./Icons/IconStylusForInput.svelte";
    import IconCancel from "./Icons/IconCancel.svelte";
    import IconCheck from "./Icons/IconCheck.svelte";
    import ErrorColor from "./ErrorColor.svelte";
    import SuccessColor from "./SuccessColor.svelte";
    import {debug} from "../../stores/store";

    export let value: string;
    export let onChange: (value: string) => void;
    export let disabled: boolean = false;
    export let showEditIcon: boolean = true;
    export let styleMode: 'blue'|'black'|'italic'|'white' = 'blue';

    export let editMode: boolean = false;
    let originalValue: string = value;

    $: console.log('InputTextInline', value);


</script>


<div class="container" class:disabled>
    {#if editMode && !disabled}
        <div class="edit-mode">
            <input type="text"
                bind:value
                on:focusout={e=> {
                    console.log('focusout', value);
                    onChange(value);
                    editMode = false;
                }}
                class="input edit-mode-{styleMode}"
                autofocus
                on:keydown={e => {
                    if (e.key === 'Enter') {
                        console.log('enter pressed', value);
                        onChange(value);
                        editMode = false;
                    }
                }}
            />
        </div>
    {:else}
        <div class="view-mode">
            <span on:click={() => { editMode=!disabled; }} class="input-not-edit-mode view-mode-{styleMode}">{value}</span>
            {#if showEditIcon && !disabled}
                <IconStylusForInput on:click={()=> { editMode=true; }}/>
            {/if}
        </div>
    {/if}
</div>


<style>
    .container {
        display: flex;
        align-items: center;
        column-gap: 5px;
    }
    .container.disabled .input-not-edit-mode {
        /*color: #888;*/
        cursor: not-allowed;
        /*border-bottom: 1px solid transparent;*/
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .edit-mode {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        column-gap: 7px;
    }
    .view-mode {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        column-gap: 7px;
        width:100%;
    }
    .input.edit-mode-blue{
        border-bottom: 1px solid #1c5dc788;
    }
    .input.edit-mode-black {
        border-bottom: 1px solid #999;
    }
    .input.edit-mode-white {
        border-bottom: 1px solid #999;
    }
    .view-mode-italic {
        /*color: #000;*/
        font-style: italic;
    }
    .input {
        border: none;
        /*border-bottom: 1px solid black;*/
        outline: none;
        padding: 0 0 0 3px;
        margin: 0 0 0 4px;
        width: 100%;
        font-size: inherit;
        /*color: #1c5dc7;*/
        font-family: inherit;
        background-color: transparent;
        color: inherit;
    }
    .input-not-edit-mode {
        /*color: #1c5dc7;*/
        /*margin: 5px 4px 0 4px;*/
        cursor: text;
        /*border-bottom: 1px solid transparent;*/
        min-width: 30px;
        min-height: 15px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
    }
    .input-not-edit-mode:hover {
        /*border-bottom: 1px solid #1c5dc7;*/
        /*color: #1c5dc7;*/
    }
    .input:focus {
        /*background-color: var(--main-selected-background);*/
    }
    span {
        margin: 0 0 0 5px;
    }
</style>